<div class="flex items-center justify-between gap-3 pl-7 pr-4">
  <div class="flex items-center gap-3">
    <button
      class="relative inline-flex h-16 items-center"
      [ngClass]="{
        'pointer-events-none': vm().appointmentDetails.isPreRegistrationAppointment
      }"
      (click)="onAvatarClick()"
    >
      <lib-avatars
        class="mr-4 cursor-pointer"
        [size]="44"
        [persons]="[vm().person]"
        [hasHealthHistorySeverityIcon]="true"
        [healthHistorySeverity]="vm().healthHistorySeverity"
      />
    </button>

    <div class="flex flex-col gap-1 text-text-primary">
      <div class="typo-h4-semibold">{{ vm().person.firstName }} {{ vm().person.lastName }}</div>
      <div class="typo-h5-light">{{ vm().phoneNumber | libPhoneFormat }}</div>
    </div>
  </div>
  @if (vm().patientId && !vm().appointmentDetails.isPreRegistrationAppointment) {
    <a
      class="flex items-center gap-x-3"
      [ffdDynamicRouterLink]="{
        routerLink: 'chartingOnSiteForPatient',
        params: [vm().siteId, vm().patientId!]
      }"
      [ffdPushTagOnClick]="{
        event: TagEvent.ChartingOpened,
        location: 'schedule',
        patient_id: vm().patientId!
      }"
      [appQueryParams]="{ fromHome: true }"
    >
      <h4 class="typo-h4-bold text-primary-blue">{{ 'schedule_details_chart' | translate }}</h4>
      <div class="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-blue text-text-white drop-shadow-icon-button">
        <svg-icon class="text-text-white" key="px-24-chart" size="md"></svg-icon>
      </div>
    </a>
  }
</div>

@if (alerts().length > 0) {
  <div class="flex flex-col gap-2">
    @for (alert of alerts(); track $index) {
      <lib-schedule-alert
        [alert]="alert"
        [isExpanded]="isAlertExpanded($index)"
        (toggleExpanded)="onToggleAlert($index)"
        (clearExpandedIndex)="onClearExpandedIndex()"
      ></lib-schedule-alert>
    }
  </div>
}
<div class="flex flex-col gap-3 pl-7 pr-4">
  <div class="flex items-center justify-between">
    <div class="typo-h3-semibold uppercase tracking-wider">{{ 'schedule_details_appointment_details' | translate }}</div>
    @if (!vm().appointmentDetails.isProvisional || vm().siteId === 'showcase') {
      <svg-icon key="px-16-edit" size="sm" class="cursor-pointer text-primary-blue" (click)="onEditClick()"></svg-icon>
    } @else {
      <svg-icon
        key="px-16-edit-pending"
        size="sm"
        class="text-text-light"
        [libUiTooltip]="provisionalTooltip"
        tooltipPosition="bottom"
      ></svg-icon>
      <ng-template #provisionalTooltip>
        <div class="typo-h7-light p-2">
          {{ 'schedule_provisional_appointment_tooltip' | translate }}
        </div>
      </ng-template>
    }
  </div>

  <div class="flex flex-col">
    <div class="spaced-dot-border flex items-start justify-between gap-1 py-2">
      <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_details_appointment_reason' | translate }}</div>
      <div class="typo-h4-medium whitespace-pre-wrap text-right text-text-primary">
        {{ vm().appointmentDetails.reason }}
      </div>
    </div>
    <div class="spaced-dot-border flex items-center justify-between gap-1 py-2">
      <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_details_appointment_date' | translate }}</div>
      <div class="typo-h4-medium overflow-hidden text-ellipsis whitespace-nowrap text-right text-text-primary">
        {{ vm().appointmentDetails.date | date: 'EEE, MMM d' }}
      </div>
    </div>
    <div class="spaced-dot-border flex items-center justify-between gap-1 py-2">
      <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_details_appointment_time' | translate }}</div>
      <div class="typo-h4-medium overflow-hidden text-ellipsis whitespace-nowrap text-right text-text-primary">
        {{ vm().appointmentDetails.time.from | timeRangeFormat: vm().appointmentDetails.time.to }}
      </div>
    </div>
    <div class="spaced-dot-border flex items-center justify-between gap-1 py-2">
      <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_details_appointment_operatory' | translate }}</div>
      <div class="typo-h4-medium overflow-hidden text-ellipsis whitespace-nowrap text-right text-text-primary">
        {{ vm().appointmentDetails.operatoryname }}
      </div>
    </div>
    <div class="spaced-dot-border flex items-center justify-between gap-1 py-2">
      <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_details_appointment_provider' | translate }}</div>
      <div class="typo-h4-medium overflow-hidden text-ellipsis whitespace-nowrap text-right text-text-primary">
        {{ vm().appointmentDetails.provider }}
      </div>
    </div>
    <div class="spaced-dot-border flex items-center justify-between gap-1 py-2">
      <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_details_appointment_status' | translate }}</div>
      <div class="flex items-center gap-1">
        @if (isOpenDental()) {
          <div class="typo-h4-medium overflow-hidden text-ellipsis whitespace-nowrap text-right text-text-primary">
            {{ vm().appointmentDetails.statusDisplayName }}
          </div>
        } @else {
          @if (vm().appointmentDetails.statusColor; as vmStatusColor) {
            <lib-appointment-status-chip [statusColor]="vmStatusColor"></lib-appointment-status-chip>
          }
          <div class="typo-h4-medium overflow-hidden text-ellipsis whitespace-nowrap text-right text-text-primary">
            {{ vm().appointmentDetails.statusColor?.statusName ?? vm().appointmentDetails.status }}
          </div>
        }
      </div>
    </div>
    <div class="spaced-dot-border flex items-start justify-between gap-4 py-2">
      <div class="typo-h4-light shrink-0 text-text-tertiary">{{ 'schedule_details_appointment_notes' | translate }}</div>
      <div class="flex flex-col items-end">
        <div
          class="typo-h4-thin mb-2 min-h-[24px] overflow-hidden text-ellipsis !whitespace-pre-wrap text-right text-text-primary"
          [ngClass]="{
            'line-clamp-2': !isExpanded,
            'line-clamp-none': isExpanded
          }"
        >
          {{ vm().appointmentDetails.notes }}
        </div>
        @if (vm().appointmentDetails.notes.length > 70) {
          <button (click)="isExpanded = !isExpanded" class="typo-h4-semibold w-fit text-primary-blue">
            {{ (isExpanded ? 'schedule_details_appointment_notes_show_less' : 'schedule_details_appointment_notes_show_more') | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
